import React from "react";

import { defaultUserForm, userFields } from "../adminUtils";
import AdminTablePage from "../components/AdminTablePage";

const Users = ({
  records,
  loading,
  error,
  onCreate,
  onUpdate,
  onDelete,
  onRefresh,
  page,
  pageSize,
  total,
  onPageChange,
  onSearch,
  onSetPaused,
}) => (
  <AdminTablePage
    defaultForm={defaultUserForm}
    error={error}
    fields={userFields}
    loading={loading}
    onCreate={onCreate}
    onDelete={onDelete}
    onPageChange={onPageChange}
    onSearch={onSearch}
    onRefresh={onRefresh}
    onSetPaused={onSetPaused}
    onUpdate={onUpdate}
    page={page}
    pageSize={pageSize}
    records={records}
    subtitle="Create, update, search, block, and delete platform users."
    title="Users"
    total={total}
    type="users"
  />
);

export default Users;
